<!--  -->
<template>
  <div class="Sidebar">
    <div class="left">
      <div class="time">
        <div class="one">{{ times }}</div>
        <div class="two">{{ datas }}</div>
      </div>
      <div class="cdmuse">
        <el-menu
          :default-active="pathIndex + ''"
          background-color="#ffffff"
          text-color="#333333"
          active-text-color="#3967EE"
        >
          <div v-for="(item, index) in navList" :key="index">
            <el-menu-item
              :index="index + ''"
              v-if="!item.child.length"
              @click="navClick(item)"
              class="flex items-center"
            >
              <svg-icon
                v-if="item.icon"
                :icon-class="item.icon"
                class="mr-[15px]"
              ></svg-icon>
              <span slot="title">{{ item.title }}</span>
            </el-menu-item>

            <el-submenu :index="index + ''" v-else>
              <template slot="title">
                <div class="flex items-center">
                  <svg-icon
                    v-if="item.icon"
                    :icon-class="item.icon"
                    class="mr-[7px]"
                  ></svg-icon>
                  <span>{{ item.title }}</span>
                </div>
              </template>
              <el-menu-item
                :index="`${index}-${k}`"
                v-for="(j, k) in item.child"
                :key="k"
                @click="navClick(j)"
                >{{ j.title }}</el-menu-item
              >
            </el-submenu>
          </div>
        </el-menu>
      </div>
    </div>

    <div class="nr">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { mapGetters } from "vuex";
import { getmenuLists } from "@/utils/auth";

export default {
  computed: {
    ...mapGetters(["sidebarRouters", "sidebar"]),
  },
  data() {
    return {
      pathIndex: 0,
      navList: [],
      times: "",
      datas: "",
    };
  },
  watch: {
    "$route.path"() {
      this.get_navActive();
    },
  },
  created() {
    this.get_navActive();
    setInterval(this.getTD, 1000);
  },
  mounted() {
    // debugger
    let list = this.sidebarRouters.filter((x) => !x.hidden);
    let navList = [];
    list.forEach((item, index) => {
      navList.push({
        title: item?.title,
        icon: item?.icon,
        path: item.path,
        child: [],
        id: item?.id,
        sort: item?.sort,
      });
      const child = item.children && item.children.filter((x) => !x.hidden);
      if (child.length === 1) {
        if (child[0].path)
          navList[index].path = item.path + "/" + child[0].path;
      }
      child &&
        child.length > 1 &&
        child.forEach((x) => {
          navList[index].child.push({
            title: x?.title,
            path: item.path + "/" + x.path,
          });
        });
    });
    let lists = [];
    let menuData = JSON.parse(localStorage.getItem("menuList"));
    let menuList = menuData.newMenuList;
    let orgLevel = menuData.orgLevel;
    menuList.forEach((v) => {
      navList.forEach((h) => {
        if (v.id == h.id) {
          lists.push(h);
        }
      });
    });
    // navList.forEach((h) => {
    //   // // 基础信息菜单(G1)只有当orgLevel=1时才显示
    //   // if (h.id == "D1" || h.id == "E1" || h.id == "F1") {
    //   lists.push(h);
    //   // }
    //   // if (h.id == "G1" && orgLevel == 1) {
    //   //   lists.push(h);
    //   // }
    // });
    lists = lists.sort(function (a, b) {
      return a.sort - b.sort;
    });
    this.navList = lists;
    this.get_navActive();
  },
  methods: {
    getTD() {
      this.times = dayjs().format("HH:mm:ss");
      this.$forceUpdate();

      let data = dayjs().day();
      let week = ["日", "一", "二", "三", "四", "五", "六"];
      this.datas = dayjs().format("YYYY年MM月DD") + " " + "星期" + week[data];
    },
    navClick(item) {
      if (!item.path) return;
      this.$router.push({ path: item.path });
    },
    get_navActive() {
      // let index = this.navList.findIndex((v) => v.path == this.$route.path);
      let pathIndex = "";
      this.navList.forEach((item, index) => {
        if (item.child && item.child.length) {
          item.child.forEach((x, y) => {
            if (x.path === this.$route.path) pathIndex = `${index}-${y}`;
          });
        } else {
          if (item.path === this.$route.path) pathIndex = index;
        }
      });
      this.pathIndex = pathIndex;
    },
  },
};
</script>
<style scoped lang="scss">
.Sidebar {
  display: flex;
  padding: 20px;
  padding-top: 0;
  padding-right: 0;
  box-sizing: border-box;
  background: #ebf0ff;
  height: 100%;
  .left {
    min-width: 200px;
    margin-top: 20px;
    border-radius: 10px;
    overflow: hidden;
    height: calc(100% - 20px);
    display: flex;
    flex-direction: column;
    .time {
      height: 91px;
      width: 100%;
      text-align: center;
      padding: 10px;
      background-color: #fff;
      flex-shrink: 0;
      .one {
        font-size: 40px;
        font-family: "UnidreamLED";
      }
      .two {
        color: #585858;
        font-size: 11px;
      }
    }
    .cdmuse {
      flex: 1;
      width: 100%;
      overflow-y: scroll;
      background-color: #fff;
      padding-top: 10px;
      ::v-deep {
        .el-menu {
          border: none;
          padding: 0 !important;
        }
        div {
          border-bottom: 1px solid #f1f2f6;
          padding: 10px 15px;
        }
        div:first-child {
          border-top: 1px solid #f1f2f6;
        }
        .el-submenu .el-menu-item {
          min-width: auto;
          height: 40px;
          line-height: 40px;
        }
        .el-menu-item {
          display: flex;
          /*justify-content: center;*/
          height: 40px;
        }
        .is-active {
          background-color: rgba(17, 69, 213, 0.06) !important;
          border-radius: 6px;
        }
        .el-submenu__title:hover,
        .el-menu-item:hover {
          border-radius: 6px;
          background-color: rgba(79, 79, 79, 0.06) !important;
        }
      }
      .el-menu-item.is-active {
        font-weight: bold;
        background-color: #649de7 !important;
        color: white !important;
      }
    }
  }
  .nr {
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    /*background: #ffffff;*/
    margin: 20px 20px 0 24px;
    border-radius: 10px;
    overflow: scroll;
    box-sizing: border-box;
    min-width: 1100px;
  }
}
::-webkit-scrollbar {
  width: 0px; /* 滚动条宽度 */
  height: 0px;
}

::-webkit-scrollbar-track {
  width: 6px;
  background: rgba(#101f1c, 0.1);
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(144, 147, 153, 0.5);
  background-clip: padding-box;
  min-height: 28px;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
  transition: background-color 0.3s;
  cursor: pointer;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(144, 147, 153, 0.3);
}
@font-face {
  font-family: "UnidreamLED";
  src: url(/src/assets/DS-Digital/DS-DIGI-1.ttf); /***兼容ie9***/
  src: url(/src/assets/DS-Digital/DS-DIGI-1.ttf?#iefix)
      format("embedded-opentype"),
    /***兼容ie6-ie8***/ url("/src/assets/DS-Digital/DS-DIGI-1.ttf")
      format("woff"),
    local("UnidreamLED"), url("/src/assets/DS-Digital/DS-DIGI-1.ttf"); /***默认使用本地的***/
}
</style>
